import React, { useEffect, useState } from "react"

const ToggleButton = ({ row, value, onHandleChange, disabled, type }) => {
       
    const [isChecked, setIsChecked] = useState(value)
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked)
        onHandleChange(row.original.id, !isChecked, row)
    }
    useEffect(()=>{
        setIsChecked(value)
    }, [value])

    return (
        <>
            <label className="autoSaverSwitch relative inline-flex cursor-pointer select-none items-center">
                <input
                    type="checkbox"
                    name="autoSaver"
                    className="sr-only"
                    checked={ isChecked }
                    onChange={ handleCheckboxChange }
                    disabled={ disabled }
                />
                <span
                    className={ `slider mr-3 flex h-[26px] w-[50px] items-center rounded-full p-1 duration-200 ${
                        isChecked ? "bg-primary-100" : "bg-[#CCCCCE]"
                    }` }
                >
                    <span
                        className={ `dot h-[18px] w-[18px] rounded-full bg-white duration-200 translate-x-6 ${
                            isChecked ? "translate-x-[-1]" : ""
                        }` }
                    ></span>
                </span>
                {
                    type && (
                        <span className="label flex items-center text-sm font-medium text-secondary-50">
                            { isChecked ? "Yes" : "No" }
                        </span>
                    )
                }
                {
                    !type && (
                        <span className="label flex items-center text-sm font-medium text-secondary-50">
                            { isChecked ? "Active" : "Inactive" }
                        </span>  
                    )
                }
                              
            </label>
        </>
    )
}

export default ToggleButton
